import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import TablePagination from "@mui/material/TablePagination";
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  Typography,
  CircularProgress,
  Backdrop,
  Menu,
  MenuItem,
  Modal,
  InputLabel,
  Select,
  FormControl,
  TextField,
  FormHelperText,
  InputAdornment,
  IconButton,
  Dialog,
  Grid,
  Divider,
  DialogTitle,
  DialogActions,
  ListItemIcon,
  Checkbox,
  // ListItemText,
} from "@mui/material";
import { ArrowDropDown, Download, Logout } from "@mui/icons-material";

import api, { baseURL } from "../services/api";
import { clearLocalStorage, getLocalStorage } from "../utils/auth";
import { useDispatch, useSelector } from "react-redux";
import {
  setAgencyTypeStoring,
  setDashboardPageNumber,
  setDashboardSearchValue,
  setFileType,
  setReportPageNumber,
  setReportSearchValue,
  setSelectBoxInReport,
  setSelectedFileFormatId,
  setSelectedFileReports,
} from "../slice/searchPaginationSlice";
import ClearIcon from "@mui/icons-material/Clear";

const Dashboard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [fileUploadLoading, setFileUploadLoading] = useState(false);
  const [dashboardList, setDashboardList] = useState([]);
  const [count, setCount] = useState(0);
  const [demoAnchor, setDemoAnchor] = useState(null);
  const [uploadAnchor, setUploadAnchor] = useState(null);
  const [downloadCSVLoading, setDownloadCSVLoading] = useState(false);
  const [isOpenFileUploadMoadl, setIsOpenFileUploadModal] = useState(false);
  const [selectedClass, setSelectedClass] = useState(null);
  const [dataSetType, setSelectedDataSetType] = useState(null);
  const [selectedFileType, setSelectedFileType] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  // const [agenciesAll, setAgenciesAll] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [fileTypes, setFileTypes] = useState([]);
  const [formats, setFormats] = useState([]);
  const [repeatedDataResponse, setRepeatedDataResponse] = useState([]);
  const [repeatedModal, setRepeatedModal] = useState(false);
  const [openDownloadModal, setOpenDownLoadModal] = useState(false);
  const [downloadDataResponse, setDownloadDataResponse] = useState({});
  console.log("formats", formats);
  const isBBOSEAgency = formats?.some((item) => item?.class_type === 5);
  console.log(isBBOSEAgency, "isBBOSEAgency");

  const {
    dashboardPageNumber,
    dashboardSearchValue,
    fileType,
    selectedFileReports,
    selectedFileFormatId,
    agencyTypeStoring,
  } = useSelector((store) => store.searchPagination);
  
  const [errors, setErrors] = useState({});
  const [agencies, setAgencies] = useState([]);

  useEffect(() => {
    if (formats?.length || Array.isArray(formats)) {
      const agencyNames = formats.map((agency) => agency);
      setAgencies([{ name: "All", id: 0 }, ...agencyNames]);
    }
  }, [formats]);

  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState(dashboardSearchValue ? dashboardSearchValue : "" );

  useEffect(() => {
    dashboardData();
  }, [dashboardPageNumber]);
  let handler;

  useEffect(() => {
    return () => {
      clearTimeout(handler);
    };
  }, []);

  const getFileType = async (agencyId = agencyTypeStoring) => {
    try {
      let apiPath = "/agency-format/all-formats";
      if (agencyId) {
        apiPath = `/agency-format/all-formats/${agencyId}`;
      }
      const response = await api.get(apiPath);

      if (response?.data?.success) {
        setFileTypes(response?.data?.data);
        setFormats(response?.data?.data?.agencyFormats);
      }
    } catch (e) {}
  };

  const [getSharedAgenciesOptionsId, setGetSharedAgenciesOptionsId] = useState(
    []
  );

  const getSharedAgenciesOptions = async () => {
    try {
      const response = await api.get("agency/associated-agencies");

      if (response?.data?.success) {
        let data = [
          {
            id: 0,
            name: "My Data",
          },
        ];
        response?.data?.data?.[1]?.map((item) => {
          data.push({
            id: item?.agency_id,
            name: item?.access_records?.name,
          });
        });

        setGetSharedAgenciesOptionsId([...data]);
      }
    } catch (e) {}
  };

  useEffect(() => {
    getFileType();
    getSharedAgenciesOptions();
  }, []);

  console.log(getSharedAgenciesOptionsId, "getSharedAgenciesOptionsId");
  const handleSearch = (search) => {
    setSearchQuery(search);
    dispatch(setDashboardSearchValue(search));

    /*handler = setTimeout(() => {
      dashboardData(0, search);

      // setDebouncedQuery(search);
      // dispatch(setReportSearchValue(search));

      // dispatch(setReportPageNumber(0));
    }, 500);**/
  };
  // const [page, setPage] = useState(0);
  // const [searchQuery, setSearchQuery] = useState("");
  // const [debouncedQuery, setDebouncedQuery] = useState("");

  const userInfo = getLocalStorage("user")
    ? JSON.parse(getLocalStorage("user"))
    : null;
  // console.log(userInfo, "userInfo");
  const [agencyType, setgencyType] = useState(agencyTypeStoring);
  console.log(agencyType, userInfo, "agencyType");
  useEffect(() => {
    if (agencyType != agencyTypeStoring) {
      setgencyType(agencyTypeStoring);
    }
  }, [agencyTypeStoring]);
  const dashboardData = async (
    number,
    search = "",
    type = fileType,
    agency_id = agencyType
  ) => {
    try {
      setDownloadCSVLoading(true);
      let apiPatch = `upload-request/uploaded-file-list/?search=${
        search || searchQuery
      }&limit=50&offset=${50 * (number ?? dashboardPageNumber)}`;
      if (type) {
        apiPatch = `upload-request/uploaded-file-list/?search=${
          search || searchQuery
        }&limit=50&offset=${
          50 * (number ?? dashboardPageNumber)
        }&format_id=${type}`;
      }
      if (agency_id) {
        apiPatch = `${apiPatch}&agency_id=${agency_id}`;
      }
      const response = await api.get(apiPatch);
      //// console.log(response, "response");
      setDashboardList(response?.data?.data?.rows);
      setCount(response?.data?.data?.count);
      // setDashboardList(response?.data?.count);
    } catch (error) {
      toast.error(
        error?.response?.data?.error ?? "Error fetching data. Please try again."
      );
    } finally {
      setLoading(false);
      setDownloadCSVLoading(false);
    }
  };

  const handleDemoMenuClick = (event) => {
    setDemoAnchor(event?.currentTarget);
  };

  const handleDemoMenuClose = (pathName, fileName) => {
    setDemoAnchor(null);
    if (pathName) {
      downloadDemoFileCsv(pathName, fileName);
    }
    // if (option === "dbf") downloadDemoFileDbf();
  };

  const handleChangePage = (event, newPage) => {
    dispatch(setDashboardPageNumber(newPage));
  };

  const downloadDemoFileCsv = async (pathName, fileName) => {
    let demoFileUrl;
    setDownloadCSVLoading(true);

    /*let demoFileUrl = "";
    if (userInfo?.role.toLowerCase() === "Agency1".toLowerCase()) {
     
    } else if (userInfo?.role.toLowerCase() === "Agency2".toLowerCase()) {
      demoFileUrl = "./assets/student_report_2.csv";
    }**/

    // demoFileUrl = "./assets/student_report_1.csv";
    // const anchor = document.createElement("a");
    // anchor.href = demoFileUrl;
    // anchor.download = "student_report.csv";
    // document.body.appendChild(anchor);
    // anchor.click();
    // document.body.removeChild(anchor);

    try {
      const response = await api.get(`public/${pathName}`);
      if (response?.data?.success) {
        toast.success(response?.data?.success);
      }

      if (response) {
        downloadCSV(response?.data, fileName);
      } else {
        toast.error("CSV link not found in the response.");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.error ??
          "Error fetching the CSV link, please try again."
      );
      return null;
    } finally {
      setDownloadCSVLoading(false);
    }
  };

  // const downloadDemoFileDbf = () => {
  //   let demoFileUrl = "";

  //   /* if (userInfo?.role.toLowerCase() === "Agency1".toLowerCase()) {
  //     demoFileUrl = "./assets/student_report_1.dbf";
  //   } else if (userInfo?.role.toLowerCase() === "Agency2".toLowerCase()) {
  //     demoFileUrl = "./assets/student_report_2.dbf";
  //   }**/

  //   const anchor = document.createElement("a");
  //   anchor.href = demoFileUrl;
  //   anchor.download = "student_report.dbf";
  //   document.body.appendChild(anchor);
  //   anchor.click();
  //   document.body.removeChild(anchor);
  // };

  const handleUploadMenuClick = (event) => {
    setIsOpenFileUploadModal(true);
    //// setUploadAnchor(event?.currentTarget);
  };

  const handleUploadMenuClose = (option) => {
    console.log(option, "option");
    setUploadAnchor(null);
    if (option) document.getElementById(`fileInput-${option}`).click();
  };
  const clearFileState = () => {
    setSelectedClass(null);
    setSelectedDataSetType(null);
    setSelectedFileType(null);
    setUploadedFile(null);
  };
  const apiCall = async (event, fileType) => {
    const file = uploadedFile;
    if (!file) {
      toast.error("No file selected!");
      return;
    }

    const formData = new FormData();
    if (dataSetType === "0") {
      // formData.append("format_id", 157);
    }
    if (dataSetType !== "0") {
      formData.append("format_id", dataSetType);
    }
    // if (dataSetType) {
    //   formData.append("format_id", dataSetType);
    // }
    if (selectedFileType) {
      formData.append("file_format", selectedFileType?.toLowerCase());
    }
    formData.append("file", file);

    /* formData.append(
      "uploadedBy",
      getLocalStorage("user")
        ? JSON.parse(getLocalStorage("user"))?.id
        : undefined
    );
    formData.append("classType", selectedClass);
    formData.append("datasetType", dataSetType);
    formData.append("fileType", selectedFileType);**/

    setFileUploadLoading(true);
    try {
      const response = await api.post("upload-request/upload-file", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response?.data?.success) {
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }
      if (
        Array.isArray(response?.data?.data?.duplicateBarcodes) &&
        response?.data?.data?.duplicateBarcodes?.length
      ) {
        setRepeatedDataResponse(response?.data?.data?.duplicateBarcodes);
        setRepeatedModal(true);
      }
      setIsOpenFileUploadModal(false);
      clearFileState();
      dashboardData();
    } catch (error) {
      console.log(
        error?.response?.data?.message,
        error,
        error?.response?.data,
        "errormessage"
      );
      toast.error(
        error?.response?.data?.message &&
          typeof error?.response?.data?.message === "string"
          ? error?.response?.data?.message
          : "File upload failed. Please try again."
      );
    } finally {
      setFileUploadLoading(false);
    }
  };

  const formatCustomDate = (date) => {
    if (!date) return "-";

    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = d.toLocaleString("en-US", { month: "short" });
    const year = d.getFullYear();
    const time = d.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    return `${day}-${month}-${year} ${time}`;
  };
  const [downLoadCsvLoader, setDownLoadCsvLoader] = useState(false);
  const handleDownloadCSV = async (csvId, fileName, newName) => {
    if (newName) {
      let demoFileUrl = `${baseURL}${newName}`;
      console.log(demoFileUrl, "demoFileUrl");
      const anchor = document.createElement("a");
      anchor.href = demoFileUrl;
      anchor.download = fileName;
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      setOpenDownLoadModal(false);
    } else {
      setDownLoadCsvLoader(true);
      try {
        const response = await api.get(`agency/download/${csvId}`);
        if (response?.data?.success) {
          toast.success(response?.data?.success);
        }

        if (response) {
          downloadCSV(response?.data, fileName);
        } else {
          toast.error("CSV link not found in the response.");
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.error ??
            "Error fetching the CSV link, please try again."
        );
        return null;
      } finally {
        setDownLoadCsvLoader(false);
      }
    }
  };

  // const downloadCSV = (csvLink) => {
  //   if (csvLink) {
  //     const fileUrl = csvLink;
  //     const anchor = document.createElement("a");
  //     anchor.href = fileUrl;
  //     document.body.appendChild(anchor);
  //     anchor.click();
  //     document.body.removeChild(anchor);
  //   } else {
  //     console.error("Invalid CSV link provided.");
  //   }
  // };
  const downloadCSV = (csvData, fileName = "data.csv") => {
    if (!csvData) {
      console.error("Invalid CSV data provided.");
      return;
    }

    // Convert data to a Blob (CSV format)
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });

    // Create a URL for the Blob
    const url = URL.createObjectURL(blob);

    // Create a hidden anchor tag and trigger download
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);

    // Clean up the URL
    URL.revokeObjectURL(url);
    setOpenDownLoadModal(false);
  };

  // Example usage with CSV string:

  const handleRowClick = (id) => {
    dispatch(setReportPageNumber(0));
    dispatch(setReportSearchValue(""));
    dispatch(setSelectBoxInReport(""));
    navigate(`/report/${id}`);
  };

  const logoutUser = () => {
    clearLocalStorage();
    navigate("/login");
  };
  const submitData = () => {
    //

    // if (!selectedClass) {
    //   setErrors({ ...errors, selectedClass: "Please Select Class" });
    //   // return toast.error("Please Select Class Type");
    // }
    // if (!dataSetType) {
    //   setErrors({ ...errors, dataSetType: "Please Select DataSet Type" });

    //   // return toast.error("Please Select DataSet Type");
    // }
    // if (!selectedFileType) {
    //   setErrors({ ...errors, selectedFileType: "Please Select File Type" });

    //   // return toast.error("Please Select File Type");
    // }
    // if (!uploadedFile) {
    //   setErrors({ ...errors, uploadedFile: "Please Upload File " });

    //   // return toast.error("Please Upload File");
    // }

    const newErrors = {}; // Collect all errors first

    if (!selectedClass) {
      newErrors.selectedClass = "Please Select Class";
    }

    if (!dataSetType) {
      newErrors.dataSetType = "Please Select DataSet Type";
    }

    if (!selectedFileType) {
      newErrors.selectedFileType = "Please Select File Type";
    }

    if (!uploadedFile) {
      newErrors.uploadedFile = "Please Upload File";
    }

    // Update errors state once (this ensures all errors are displayed)
    if (Object.keys(newErrors).length > 0) {
      setErrors({ ...errors, ...newErrors });
      return; // Prevent further execution
    }
    if (selectedClass && dataSetType && selectedFileType && uploadedFile) {
      apiCall();
    }
  };
  // const menuItems = {
  //   Matric: [
  //     // { key: "Matric_Practical_Raw_DATA", label: "Matric Practical Raw DATA" },
  //     { key: "MATRIC_PRACTICAL_DATA", label: "Matric Practical DATA" },
  //     // { key: "MATRIC_OMR_RAW_DATA", label: "MATRIC OMR RAW DATA" },
  //     { key: "MATRIC_OMR_DATA", label: "MATRIC OMR DATA" },
  //     // { key: "MATRIC_FOIL_RAW_DATA", label: "MATRIC FOIL RAW DATA" },
  //     { key: "MATRIC_FOIL_DATA", label: "MATRIC FOIL DATA" },
  //     // { key: "MATRIC_AWARD_RAW_DATA", label: "MATRIC AWARD RAW DATA" },
  //     { key: "MATRIC_AWARD_DATA", label: "MATRIC AWARD DATA" },
  //   ],
  //   Inter: [
  //     // { key: "INTER_PRACTICAL_RAW_DATA", label: "INTER PRACTICAL RAW DATA" },
  //     { key: "INTER_PRACTICAL_DATA", label: "INTER PRACTICAL DATA" },
  //   ],
  // };
  const chooseFile = () => {
    if (!selectedFileType) {
      toast.error("Please Select File Type");
      return;
    }
    if (selectedFileType) {
      handleUploadMenuClose(selectedFileType?.toLowerCase());
      return;
    }
    // if (selectedFileType == "DBF") {
    //   handleUploadMenuClose("dbf");
    //   return;
    // }
    // if (selectedFileType == "CSV") {
    //   handleUploadMenuClose("csv");
    //   return;
    // }
    // if (selectedFileType == "CSV") {
    //   handleUploadMenuClose("csv");
    //   return;
    // }
    // if (selectedFileType == "CSV") {
    //   handleUploadMenuClose("csv");
    //   return;
    // }
  };
  const onUploadFile = (e) => {
    const file = e.target.files[0];
    setUploadedFile(file);
    e.target.value = null;
  };

  const handleCloseFileMOdal = () => {
    setUploadedFile(null);
    setSelectedFileType(null);
    setSelectedDataSetType(null);
    setSelectedClass(null);
    setErrors({});
    setIsOpenFileUploadModal(false);
  };
  const getFileTypes = () => {
    const VALUES = {
      Matric: 2,
      Inter: 1,
      Iti: 4,
      BBOSE: 5,
      SIMULTALA_6: 6,
      SIMULTALA_11: 7,
      Deled: 8,
      Dped: 9
    };
    // if (selectedClass == "BBOSE") {
    //   return [
    //     {
    //       id: "0",
    //       name: "BBOSE Format",
    //       path: null,
    //       table_name: "BBose",
    //     },
    //   ];
    // }
    if (selectedClass) {
      const filterData = fileTypes?.agencyFormats?.filter(
        (item) => item?.class_type == VALUES[selectedClass]
      );
      //delete if not  required

      // if (userInfo?.agencyId == 27) {
      //   return [
      //     ...filterData,
      //     {
      //       id: "0",
      //       name: "Outlayer",
      //       path: null,
      //       table_name: "Outlayer",
      //     },
      //   ];
      // }
      //till here
      return filterData;
    } else {
      return [];
    }
  };
  const getMasterDataCheck = (id) => {
    let data = fileTypes?.agencyFormats?.filter((item) => item?.id == id);
    if (data?.length) {
      if (data[0]?.name?.toLowerCase() === "MasterData"?.toLowerCase()) {
        return true;
      }
    }
    return false;
  };
  const searchRecord = () => {
    dispatch(setDashboardPageNumber(0));

    dashboardData(0, searchQuery);
  };

  // const [selectedRows, setSelectedRows] = useState([]);
  // console.log(selectedRows, "selectedRows");
  // // Function to handle selection
  // const handleSelectRow = (id) => {
  //   setSelectedRows((prev) =>
  //     prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
  //   );
  // };

  // const handleMultiDownLoad = async () => {
  //   try {
  //     setDownloadCSVLoading(true);

  //     const response = await api.post("donwloads/", {
  //       id: [...selectedRows],
  //     });

  //     if (response?.data?.success) {
  //       toast.success(response?.data?.message ?? "Download in process...!");
  //       setSelectedRows([]);
  //     } else {
  //       toast.error(response?.data?.message);
  //     }
  //   } catch (error) {
  //     toast.error(
  //       error?.response?.data?.error ??
  //         "Error creating Agency. Please try again."
  //     );
  //   } finally {
  //     setDownloadCSVLoading(false);
  //   }
  // };

  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (event, newValue) => {
    console.log(newValue, "newValue");
    setSelectedTab(newValue);
  };

  const [selectedRows, setSelectedRows] = useState([...selectedFileReports]);
  const [selectedFormat, setSelectedFormat] = useState(selectedFileFormatId);

  useEffect(() => {
    dispatch(setSelectedFileFormatId(selectedFormat));
  }, [selectedFormat]);
  useEffect(() => {
    dispatch(setSelectedFileReports(selectedRows));
  }, [selectedRows?.length]);
  console.log(selectedRows, "selectedRows");
  //// Function to handle selection
  const handleSelectRow = (id, formatId) => {
    if (selectedFormat !== formatId) {
      setSelectedFormat(formatId);
    }
    if (
      selectedRows.length === 1 &&
      selectedFormat == formatId &&
      selectedRows.includes(id)
    ) {
      setSelectedFormat(null);
    }
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleMultiDownLoad = async () => {
    try {
      setDownloadCSVLoading(true);
      let data = {
        format_id: selectBox == 0 ? selectedFormat : selectBox,
        upload_id: [...selectedRows],
      };
      // const response = await api.post("agency/consolidated-download", data, {
      //   responseType: "blob", // Important: tells axios to handle binary data
      // });
      const response = await api.post("agency/consolidated-download", data);
      console.log(response, "response");
      // if (response?.data?.type === "application/json") {
      //   toast.error("Something went wrong");
      //   return;
      // }
      if (response?.data?.success) {
        // toast.success(response?.data?.message ?? "Download in process...!");

        // let url = window.URL.createObjectURL(new Blob([response.data]));
        // const link = document.createElement("a");
        // link.href = url;
        // link.setAttribute("download", "consolidated_data.csv"); // Set file name
        // document.body.appendChild(link);
        // link.click();
        // link.remove();
        toast.success(response?.data?.message);
        setSelectedRows([]);
        setSelectedFormat(null);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.error ?? "Error Downloading. Please try again."
      );
    } finally {
      setDownloadCSVLoading(false);
    }
  };

  const [selectBox, setSelectBox] = useState(fileType);
  // useEffect(() => {
  //   dashboardData(0, searchQuery, fileType);
  // }, [fileType]);
  const handleChangeSelectBox = (data) => {
    setSelectBox(data?.target?.value);
    dispatch(setFileType(data?.target?.value));
    dashboardData(0, searchQuery, data?.target?.value);

    console.log(data?.target?.value, "data?.target?.value");
    if (selectBox !== data?.target?.value?.id) {
      setSelectedRows([]);
      setSelectedFormat(null);
    }
    // dispatch(setSelectBoxInReport(data?.target?.value));
  };

  useEffect(() => {
    if (getSharedAgenciesOptionsId?.length && !agencyTypeStoring) {
      setgencyType(Number(getSharedAgenciesOptionsId?.[0]?.id));
      dispatch(
        setAgencyTypeStoring(Number(getSharedAgenciesOptionsId?.[0]?.id))
      );
    }
  }, [getSharedAgenciesOptionsId, agencyTypeStoring]);
  const handleAgencyType = (data) => {
    setgencyType(data?.target?.value);
    dispatch(setAgencyTypeStoring(data?.target?.value));

    getFileType(data?.target?.value);
    setSelectedRows([]);
    setSelectedFormat(null);
    setSelectBox(0);
    dispatch(setFileType(0));

    dashboardData(0, searchQuery, null, data?.target?.value);
  };

  ////console.log(agencyType, "agencyType");

  function isNotAllowedExtension(filePath) {
    // Extract the file extension
    const extension = filePath?.split(".")?.pop()?.toLowerCase();

    // Check if it's "mdb" or "bak"
    return extension === "mdb" || extension === "bak";
  }

  const checkMay18 = (dateString) => {
    if (!dateString) return false; // Handle undefined/null dates

    const date = new Date(dateString);

    console.log("Checking date:", date.toISOString()); // Debug log

    const utcDate = date.getUTCDate();
    const utcMonth = date.getUTCMonth() + 1; // Months are 0-based
    const utcYear = date.getUTCFullYear();

    return utcYear === 2025 && utcMonth === 3 && utcDate === 18;
  };
  const hideIds = [131, 130, 129, 127, 126, 623, 624, 629, 628, 627, 626, 625];

  const handleShowHideRecords = (row) => {
    // if (
    //   row?.id === 351 ||
    //   row?.id === 350 ||
    //   row?.id === 346 ||
    //   row?.id == 311
    // ) {
    //   return false;
    // }

    //delete if not  required
    // if (userInfo?.agencyId == 54) {
    //   if (row?.id == 379) {
    //     return true;
    //   } else return false;
    // }
    if (userInfo?.agencyId == 20 || userInfo?.agencyId == 54) {
      if (agencyType == 27) {
        if (row?.id == 379 || row?.id > 500) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
    if (row?.id == 371 || row?.id == 379) {
      if (userInfo?.agencyId == 27 || userInfo?.agencyId == 54) {
        return true;
      } else {
        return false;
      }
    }
    if (agencyType == 27 && row?.id === 217) {
      if (userInfo?.agencyId == 21 || userInfo?.agencyId == 53) {
        return true;
      } else {
        return false;
      }
    }
    //till here
    if (
      userInfo?.agencyId === 24 ||
      userInfo?.agencyId === 21 ||
      userInfo?.agencyId === 27 ||
      userInfo?.agencyId === 23 ||
      userInfo?.agencyId === 19 ||
      userInfo?.agencyId === 53
    ) {
      return true;
    } else {
      if (hideIds.includes(row?.id)) {
        return false;
      } else if (agencyType === 24 && checkMay18(row?.createdAt)) {
        return false;
      } else {
        return true;
      }
    }
  };

  const handleDisableFrontend = (row) => {
    if (row?.format_details?.name?.toLowerCase()?.includes("bbose")) {
      return true;
    }
    if (row?.format_id == "157") {
      return true;
    }
    return row?.id > 320 &&
      (userInfo?.agencyId == 27 ||
        // agencyType == 53 ||
        // userInfo?.agencyId == 21 ||
        agencyType == 27) &&
      row?.format_id == "66"
      ? true
      : false;
  };
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }
  const handleRepeatedModalClose = () => {};
  return (
    <>
      {/* Image Section */}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        mb={1}
        mt={2}
      >
        <Box textAlign="center">
          <img
            src="./full-logo.png"
            alt="Bihar Board Examination"
            title="Bihar Board Examination"
            style={{ maxWidth: "100%", height: "68px" }}
          />
        </Box>
      </Box>
      <div style={{ height: "54px", backgroundColor: "#8C0001" }} />
      <Container maxWidth="lg" style={{ marginTop: "24px" }}>
        {fileUploadLoading ? (
          <Backdrop
            open={fileUploadLoading}
            style={{ zIndex: 9999, color: "#fff" }}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        ) : null}

        <Box
          // display="flex"
          flexWrap="wrap"
          gap="10px"
          // justifyContent="space-between"
          alignItems="center"
          mb={3}
        >
          <Box
            display="flex"
            // flexWrap="wrap"
            gap="10px"
            // justifyContent="space-between"
            mb={2}
          >
            <Typography
              variant="h4"
              sx={{
                fontSize: { xs: "1.3rem", sm: "1.5rem", md: "1.8rem" },
              }}
            >
              {userInfo?.name} {""}
              Dashboard
            </Typography>
            <Box
              style={{
                marginLeft: "auto",
              }}
            >
              <FormControl
                size="small"
                style={{
                  width: "250px",
                  marginRight: "10px",
                }}
                fullWidth
                variant="outlined"
              >
                <InputLabel
                  id="demo-simple-select"
                  shrink={Boolean(agencyType?.toString())}
                >
                  Agency Type
                </InputLabel>
                <Select
                  labelId="demo-simple-select"
                  id="demo-simple-selects"
                  value={agencyType === 0 || agencyType ? agencyType : null}
                  label="Agency type"
                  onChange={handleAgencyType}
                  style={{
                    width: "250px",
                    marginLeft: "auto",
                  }}
                >
                  {getSharedAgenciesOptionsId?.map((item) => {
                    return (
                      <MenuItem key={item} value={item?.id}>
                        {item?.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>

              <FormControl
                size="small"
                style={{
                  width: "250px",
                  marginLeft: "auto",
                }}
                fullWidth
              >
                <InputLabel id="demo-simple-select-label">File Type</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectBox}
                  label="File type"
                  onChange={handleChangeSelectBox}
                  style={{
                    width: "250px",
                  }}
                >
                  {agencies?.map((item) => {
                    return (
                      item !== "position" && (
                        <MenuItem key={item} value={item?.id}>
                          {item?.name}
                        </MenuItem>
                      )
                    );
                  })}
                </Select>
              </FormControl>
            </Box>
          </Box>
          <Box display="flex" flexWrap="wrap" alignItems="center" gap={2}>
            {/* Demo File Dropdown */}
            <TextField
              id="standard-basic"
              label="Search..."
              variant="outlined"
              // onChange={(e) => setSearchQuery(e.target.value)}
              onChange={(e) => handleSearch(e.target.value)}
              value={searchQuery}
              size="small"
              InputProps={{
                endAdornment: searchQuery && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        handleSearch("");
                      }}
                      edge="end"
                      size="small"
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={searchRecord}
              style={{
                textTransform: "none",
                backgroundColor: "#8C0001",
              }}
            >
              Search
            </Button>
            {agencyType == 0 && (
              <Box>
                <Button
                  variant="outlined"
                  color="primary"
                  endIcon={<ArrowDropDown />}
                  onClick={handleDemoMenuClick}
                  style={{ textTransform: "none" }}
                >
                  Download Template
                </Button>
                <Menu
                  anchorEl={demoAnchor}
                  open={Boolean(demoAnchor)}
                  onClose={() => handleDemoMenuClose()}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  PaperProps={{
                    sx: {
                      mt: "7px", // Moves the dropdown 5px upward
                    },
                  }}
                >
                  {formats?.map((item) => {
                    return (
                      item?.path && (
                        <MenuItem
                          color="primary"
                          onClick={() =>
                            handleDemoMenuClose(item?.path, item?.name)
                          }
                        >
                          <ListItemIcon>
                            <Download
                              style={{
                                color: "#8C0001",
                                width: "20px",
                              }}
                              size={"small"}
                            />
                          </ListItemIcon>
                          {item?.name}
                        </MenuItem>
                      )
                    );
                  })}
                  {/* <MenuItem onClick={() => handleDemoMenuClose("csv")}>
                    Download CSV
                  </MenuItem>
                  <MenuItem onClick={() => handleDemoMenuClose("dbf")}>
                    Download DBF
                  </MenuItem> */}
                </Menu>
              </Box>
            )}

            {/* Upload File Dropdown */}
            {agencyType == 0 && (
              <Box>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleUploadMenuClick}
                  style={{ textTransform: "none" }}
                >
                  Upload File
                </Button>
                <Menu
                  anchorEl={uploadAnchor}
                  open={Boolean(uploadAnchor)}
                  onClose={() => handleUploadMenuClose(null)}
                >
                  <MenuItem onClick={() => handleUploadMenuClose("csv")}>
                    Upload CSV
                  </MenuItem>
                  <MenuItem onClick={() => handleUploadMenuClose("dbf")}>
                    Upload DBF
                  </MenuItem>
                  {}
                </Menu>
              </Box>
            )}

            {/* Hidden file inputs */}
            <input
              id="fileInput-csv"
              type="file"
              hidden
              accept=".csv"
              onChange={onUploadFile}
              // onChange={(e) => handleFileChange(e, "csv")}
            />
            <input
              id="fileInput-dbf"
              type="file"
              hidden
              accept=".dbf"
              //onChange={(e) => handleFileChange(e, "dbf")}
              onChange={onUploadFile}
            />
            <input
              id="fileInput-mdb"
              type="file"
              hidden
              // accept=".mdb"
              accept=".mdb, application/octet-stream"
              //onChange={(e) => handleFileChange(e, "dbf")}
              onChange={onUploadFile}
            />
            <input
              id="fileInput-xlsx"
              type="file"
              hidden
              accept=".xlsx"
              //onChange={(e) => handleFileChange(e, "dbf")}
              onChange={onUploadFile}
            />
            <input
              id="fileInput-bak"
              type="file"
              hidden
              accept=".bak"
              //onChange={(e) => handleFileChange(e, "dbf")}
              onChange={onUploadFile}
            />

            {/* Logout Button */}

            {selectedRows?.length > 1 && (
              <Button
                onClick={handleMultiDownLoad}
                variant="outlined"
                // disabled={true}
                startIcon={<Download />}
                style={{ color: "#8C0001", borderColor: "#8C0001" }}
              >
                Download Consolidated Files
              </Button>
            )}

            <Button
              variant="contained"
              color="error"
              startIcon={<Logout />}
              onClick={logoutUser}
              style={{ textTransform: "none", marginLeft: "auto" }}
            >
              Logout
            </Button>
          </Box>
        </Box>

        {/* <AppBar
          position="static"
          sx={{ backgroundColor: "white", boxShadow: "none" }}
        >
          <Tabs
            value={selectedTab}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            {agencies?.map((agency, index) => (
              <Tab
                key={index}
                label={agency}
                sx={{
                  fontSize: "12px",

                  // minHeight: "52px",
                  // padding: "6px 12px",
                }}
              />
            ))}
          </Tabs>
        </AppBar> */}

        <TableContainer
          // sx={{ maxHeight: "58vh", overflow: "auto" }}
          component={Paper}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow style={{ textWrap: "nowrap", textAlign: "center" }}>
                <TableCell align="center">
                  <strong>CSV Name</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>Tag</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>Total Records</strong>
                </TableCell>
                {/* <TableCell align="center">
                  <strong>Total Edited Records</strong>
                </TableCell>
                <TableCell align="center">
                  <strong>Total Approval Records</strong>
                </TableCell> */}
                <TableCell align="center">
                  <strong>Updated At</strong>
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    position: "sticky",
                    right: 0,
                    background: "white", // Ensures it stays visible
                    zIndex: 2, // Ensures it stays above other columns
                  }}
                >
                  <strong>Action</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dashboardList?.length > 0 ? (
                dashboardList?.map((row) =>
                  // (agencyType === 24 || userInfo?.agencyId === 24) &&
                  // checkMay18(row?.createdAt) ? null : hideIds?.includes(
                  //     row?.id
                  //   ) ? null : (
                  !handleShowHideRecords(row) ? null : (
                    <TableRow
                      key={row?.id}
                      style={{ textWrap: "nowrap", textAlign: "center" }}
                    >
                      <TableCell style={{ textAlign: "left" }}>
                        <div>
                          <Checkbox
                            checked={selectedRows.includes(row?.id)}
                            onChange={() =>
                              handleSelectRow(row?.id, row?.format_id)
                            }
                            style={{
                              marginTop:
                                row?.csv_name?.length > 44 ? "-20px" : "0px",
                            }}
                            color="primary"
                            disabled={
                              selectedFormat
                                ? selectedFormat !== row?.format_id
                                : false
                            }
                          />
                          <span
                            style={{
                              display: "inline-block",
                              width: "320px",
                              whiteSpace: "normal",
                              wordBreak: "break-all",
                              overflowWrap: "break-all",
                            }}
                          >
                            {/* {row?.csv_name
                              ? row?.csv_name
                                  ?.split("/")
                                  ?.pop()
                                  ?.replace(/\.[^.]+$/, "")
                              : "-"} */}

                            {row?.csv_name
                              ? row?.csv_name
                                  ?.split("/")
                                  ?.pop()
                                  ?.replace(/\.[^.]+$/, "")
                                  .slice(0, 100) +
                                (row?.csv_name?.length > 100 ? "..." : "")
                              : "-"}
                          </span>
                        </div>
                      </TableCell>
                      {/* <TableCell style={{ textAlign: "left" }}>
                      {row?.csv_name
                        ? // ? row?.csv_name?.split("/")?.pop()?.split(".")?.[0]
                          row?.csv_name
                            ?.split("/")
                            ?.pop()
                            ?.replace(/\.[^.]+$/, "")
                        : "-"}
                    </TableCell> */}
                      <TableCell align="center">
                        {
                          // row?.id === 482
                          //   ? "Admit Card Data"
                          //   : row?.id === 483 || row?.id === 484
                          //   ? "Duplicate Data"
                          //   : //delete if not  required

                          // row?.id > 320 &&
                          // (userInfo?.agencyId == 27 ||
                          //   // agencyType == 53 ||
                          //   // userInfo?.agencyId == 21 ||
                          //   agencyType == 27) &&
                          // row?.format_id == "66"
                          //   ? "Outlayer"
                          //   : ///till here
                          row?.format_details?.name
                            ? row?.format_details?.name
                            : "_"
                        }
                      </TableCell>
                      <TableCell align="center">
                        {isNotAllowedExtension(row?.csv_name)
                          ? "NA"
                          : row?.format_details?.name?.toLowerCase() ===
                              "MasterData"?.toLowerCase() ||
                            row?.format_details?.name?.toLowerCase() ===
                              "WantingData"?.toLowerCase() ||
                            row?.format_details?.name?.toLowerCase() ===
                              "ResultCollection"?.toLowerCase() ||
                            row?.format_details?.name?.toLowerCase() ===
                              "OutLayer"?.toLowerCase()
                          ? "NA"
                          : row?.total_number_records
                          ? row?.total_number_records
                          : 0}
                      </TableCell>
                      {/* <TableCell align="center">
                      {row?.total_edited_records
                        ? row?.total_edited_records
                        : 0}
                    </TableCell>
                    <TableCell align="center">
                      {row?.total_approved_records
                        ? row?.total_approved_records
                        : 0}
                    </TableCell> */}
                      <TableCell align="center">
                        {row?.createdAt
                          ? formatCustomDate(row?.createdAt)
                          : "-"}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          position: "sticky",
                          right: 0,
                          background: "white", // Ensures it stays visible
                          zIndex: 1, // Ensures it stays above other columns
                          marginTop: "6px",
                        }}
                        style={{ display: "flex", gap: "10px" }}
                      >
                        <Button
                          variant="text"
                          color="primary"
                          style={{
                            textTransform: "none",
                            color: "#8C0001",
                            borderColor: "#8C0001",
                          }}
                          startIcon={<Download />}
                          onClick={() => {
                            // setDownloadDataResponse(row);
                            // setOpenDownLoadModal(true);

                            handleDownloadCSV(
                              row?.id,

                              row?.csv_name
                                ?.split("/")
                                ?.pop()
                                ?.replace(/\.[^.]+$/, ""),
                              row?.csv_name
                            );
                          }}
                        >
                          Download
                        </Button>

                        <Button
                          variant="contained"
                          style={{
                            textTransform: "none",
                            backgroundColor: "#8C0001",
                            cursor: handleDisableFrontend(row)
                              ? "not-allowed"
                              : isNotAllowedExtension(row?.csv_name)
                              ? "not-allowed"
                              : row?.format_details?.name?.toLowerCase() ===
                                  "MasterData"?.toLowerCase() ||
                                row?.format_details?.name?.toLowerCase() ===
                                  "WantingData"?.toLowerCase() ||
                                row?.format_details?.name?.toLowerCase() ===
                                  "ResultCollection"?.toLowerCase() ||
                                row?.format_details?.name?.toLowerCase() ===
                                  "OutLayer"?.toLowerCase()
                              ? "not-allowed"
                              : "pointer",
                          }}
                          size="small"
                          onClick={() => {
                            if (handleDisableFrontend(row)) {
                              return;
                            }
                            if (isNotAllowedExtension(row?.csv_name)) {
                              return;
                            } else if (
                              row?.format_details?.name?.toLowerCase() !==
                                "MasterData"?.toLowerCase() &&
                              row?.format_details?.name?.toLowerCase() !==
                                "WantingData"?.toLowerCase() &&
                              row?.format_details?.name?.toLowerCase() !==
                                "ResultCollection"?.toLowerCase() &&
                              row?.format_details?.name?.toLowerCase() !==
                                "OutLayer"?.toLowerCase()
                            ) {
                              handleRowClick(row?.id);
                            }
                          }}
                          // disabled={
                          //   row?.format_details?.name?.toLowerCase() ===
                          //   "MasterData"?.toLowerCase()
                          // }
                        >
                          View Report
                        </Button>
                      </TableCell>
                    </TableRow>
                  )
                )
              ) : (
                <TableRow>
                  <TableCell colSpan={5} style={{ textAlign: "center" }}>
                    No records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          // rowsPerPageOptions={[5, 10, 25, 30]}
          rowsPerPageOptions={undefined}
          component="div"
          count={count}
          rowsPerPage={rowsPerPage}
          page={dashboardPageNumber}
          onPageChange={handleChangePage}

          // onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Container>
      <Modal open={isOpenFileUploadMoadl}>
        <Box
          display="flex"
          flexDirection="column"
          gap={2}
          position="absolute"
          top="50%"
          left="50%"
          width={400}
          p={4}
          bgcolor="background.paper"
          boxShadow={24}
          borderRadius={2}
          style={{ transform: "translate(-50%, -50%)" }}
        >
          <Typography variant="h6">Upload File</Typography>
          <FormControl
            fullWidth
            variant="outlined"
            error={!!errors.selectedClass}
          >
            <InputLabel>Class</InputLabel>
            <Select
              label="class"
              name="class"
              value={selectedClass}
              onChange={(e) => {
                setSelectedDataSetType(null);
                setSelectedClass(e.target.value);

                setErrors({ ...errors, selectedClass: "" });
              }}
            >
              <MenuItem key={"Matric"} value={"Matric"}>
                Matric
              </MenuItem>
              <MenuItem key={"Inter"} value={"Inter"}>
                Inter
              </MenuItem>
              <MenuItem key={"Iti"} value={"Iti"}>
                ITI
              </MenuItem>
              {isBBOSEAgency && (
                <MenuItem key={"BBOSE"} value={"BBOSE"}>
                  BBOSE
                </MenuItem>
              )}
              <MenuItem key={"SIMULTALA_6"} value={"SIMULTALA_6"}>
                SIMULTALA CLASS VI
              </MenuItem>
              <MenuItem key={"SIMULTALA_11"} value={"SIMULTALA_11"}>
                SIMULTALA CLASS XI
              </MenuItem>
              <MenuItem key={"Deled"} value={"Deled"}>
                D.EL.ED
              </MenuItem>
              <MenuItem key={"Dped"} value={"Dped"}>
                D.P.Ed
              </MenuItem>
            </Select>
            <FormHelperText>{errors.selectedClass}</FormHelperText>
          </FormControl>
          <FormControl
            fullWidth
            variant="outlined"
            disabled={selectedClass ? false : true}
            error={!!errors.dataSetType}
          >
            <InputLabel>Dataset Type</InputLabel>
            <Select
              labelId="dataset-type-label"
              label="Dataset Type"
              name="datasetType"
              value={dataSetType}
              onChange={(e) => {
                setSelectedDataSetType(e.target.value);

                setErrors({ ...errors, dataSetType: "" });
              }}
            >
              {getFileTypes()?.map((item) => {
                return (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                );
              })}
            </Select>
            <FormHelperText>{errors.dataSetType}</FormHelperText>
          </FormControl>
          <FormControl
            fullWidth
            variant="outlined"
            error={!!errors.selectedFileType}
          >
            <InputLabel>File Type</InputLabel>
            <Select
              label="fileType"
              name="fileType"
              value={selectedFileType}
              onChange={(e) => {
                setSelectedFileType(e.target.value);
                setErrors({ ...errors, selectedFileType: "" });
              }}
            >
              {dataSetType === 83 || dataSetType === 84 ? (
                <MenuItem key="MDB" value="MDB">
                  MDB
                </MenuItem>
              ) : (
                [
                  <MenuItem key="CSV" value="CSV">
                    CSV
                  </MenuItem>,
                  <MenuItem key="MDB" value="MDB">
                    MDB
                  </MenuItem>,
                  <MenuItem key="XLSX" value="XLSX">
                    XLSX
                  </MenuItem>,
                  <MenuItem key="BAK" value="BAK">
                    BAK
                  </MenuItem>,
                  <MenuItem key="DBF" value="DBF">
                    DBF
                  </MenuItem>,
                ]
              )}
            </Select>

            <FormHelperText>{errors.selectedFileType}</FormHelperText>
          </FormControl>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <Button
              component="label"
              variant="contained"
              tabIndex={-1}
              onClick={chooseFile}
            >
              Choose File
            </Button>
            {uploadedFile ? (
              <span
                style={{
                  marginTop: "10px",
                  wordBreak: "break-word",
                  whiteSpace: "normal",
                }}
              >
                {uploadedFile?.name}
              </span>
            ) : (
              <FormHelperText>{errors.uploadedFile}</FormHelperText>
            )}
          </Box>

          <Box display="flex" justifyContent="flex-end" gap={2}>
            <Button
              variant="contained"
              // color="primary"
              onClick={submitData}
              style={{ backgroundColor: "#8C0001" }}
            >
              Upload
            </Button>
            <Button
              variant="outlined"
              onClick={handleCloseFileMOdal}
              style={{ color: "#8C0001", borderColor: "#8C0001" }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>

      <Dialog
        // open={repeatedDataResponse?.length ? true : false}
        open={repeatedModal}
        fullWidth
        onClose={() => setRepeatedModal(false)}
      >
        <DialogTitle>Duplicate Values</DialogTitle>

        <Box
          style={{
            width: "92%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
          display="flex"
          flexDirection="column"
          gap="16px"
        >
          <Grid container spacing={2} align="start">
            <Grid
              item
              xs={12}
              sm={4}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <Typography fontWeight={"bold"} color="black">
                Duplicate Barcode
              </Typography>
              <Divider />
              {repeatedDataResponse?.map((item) => {
                return <Typography>{item?.barcode}</Typography>;
              })}
            </Grid>

            <Grid
              item
              xs={8}
              sm={4}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <Typography fontWeight={"bold"} color="black">
                Position
              </Typography>
              <Divider />
              {repeatedDataResponse?.map((item) => {
                return <Typography>{item?.position}</Typography>;
              })}
            </Grid>
          </Grid>
        </Box>
        <DialogActions style={{ padding: "16px 24px" }}>
          <Button
            variant="outlined"
            onClick={() => setRepeatedModal(false)}
            style={{ color: "#8C0001", borderColor: "#8C0001" }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDownloadModal}
        onClose={() => setOpenDownLoadModal(false)}
        fullWidth
      >
        <Box>
          <Backdrop
            open={downLoadCsvLoader}
            style={{ zIndex: 1300, color: "#fff" }}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <DialogTitle>Download Record</DialogTitle>

          <Grid
            container
            item
            spacing={2}
            style={{
              margin: "8px",
            }}
          >
            {/* Field Name */}
            <Grid
              item
              // xs={4}
              style={{
                display: "flex",
                width: "92%",
                // backgroundColor: "red",
                justifyContent: "space-between",
              }}
            >
              <Typography>
                <strong>Original File</strong>
              </Typography>
              <Button
                startIcon={<Download />}
                variant="text"
                color="primary"
                style={{
                  textTransform: "none",
                  color: "#8C0001",
                  borderColor: "#8C0001",
                }}
                onClick={() => {
                  handleDownloadCSV(
                    downloadDataResponse?.id,

                    downloadDataResponse?.csv_name
                      ?.split("/")
                      ?.pop()
                      ?.replace(/\.[^.]+$/, ""),
                    downloadDataResponse?.csv_name
                  );
                }}

                // disabled={formLoading}
              >
                Download
              </Button>
            </Grid>
          </Grid>
          {/* <Typography>Original File</Typography> */}
          {downloadDataResponse?.file_history?.map((item) => {
            return (
              <Grid item xs={4}>
                <Typography>{item?.barcode}</Typography>;
              </Grid>
            );
          })}
          <DialogActions style={{ marginRight: "16px", marginBottom: "16px" }}>
            <Button
              onClick={() => {
                setOpenDownLoadModal(false);
              }}
              variant="outlined"
              style={{ color: "#8C0001", borderColor: "#8C0001" }}
            >
              Cancel
            </Button>
          </DialogActions>
        </Box>
      </Dialog>

      {/* Loader Backdrop */}
      <Backdrop
        open={downloadCSVLoading}
        style={{ zIndex: 1300, color: "#fff" }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default Dashboard;
